module.exports = __webpack_public_path__ + "img/westmount.25930d98.webp";